export default __webpack_public_path__ + "static/futuristic-ai-chip-circuit-board-6401a6def8557879014dc5bec6679c04.png";